import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { ApolloClient } from '@apollo/client';
import { PageLoading } from '../../app/components/general/PageLoading';
import { useApolloAppSyncClient } from './useApolloAppSyncClient';

/**
 * Higher-order-component (HOC) that wraps an ApolloProvider around the children component
 */
export function ApolloWrapper(props: {
  /** Child node to render */
  children: React.ReactElement;
}) {
  const { children, ...rest } = props;
  const { client } = useApolloAppSyncClient();

  // only render ApolloProvider if client created otherwise render without ApolloProvider
  return client instanceof ApolloClient ? (
    <ApolloProvider client={client}>
      {React.cloneElement(children, {
        ...rest,
      })}
    </ApolloProvider>
  ) : (
    <PageLoading />
  );
}